import styled, { keyframes, css } from 'styled-components/macro';

const RotateLoader = keyframes`
    from {
      transform: translateY(-50%) rotate(0deg);
    }
    to {
      transform: translateY(-50%) rotate(360deg);
    }
`;

export const Input = styled.input`
  ${({ theme }) => css`
    border-radius: ${theme.spacings.xs};
    outline: none;
    width: 100%;
    border: 1px solid;
    background-color: transparent;
    color: ${theme.colors.gray[800]};
    transition-duration: ${theme.tokens.animation.duration.base};
    z-index: 1;

    ${theme.fonts['body-14'].css}

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    ${theme.tokens.media.mobile} {
      ${theme.fonts['body-16'].css}
    }
  `}
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const ActionIcon = styled.img<{
  $isPending?: boolean;
  $isDisabled?: boolean;
}>`
  ${({ theme, $isDisabled, $isPending }) => css`
    margin: auto ${theme.spacings.s} auto auto;
    position: absolute;
    z-index: 2;
    top: 50%;
    right: 0;
    width: 16px;
    height: 16px;
    transform: translateY(-50%);
    cursor: pointer;

    ${$isDisabled &&
    css`
      pointer-events: none;
      cursor: not-allowed;
    `}

    ${$isPending &&
    css`
      animation: ${RotateLoader} 1000ms 0ms linear infinite;
    `}
  `}
`;
